import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Input from 'components/common/Input';
import { validateURL } from 'helpers/utils';
import { toast } from 'react-toastify';

const Socials = ({ watch, errors, setValue, smHiden }) => {
 const [open, setOpen] = useState(false);
 const [err, setErr] = useState(false);
 const [formData, setFormData] = useState({ url: '' });

 const onChange = ({ target: { value } }) => setFormData({ ...formData, url: value });

 const onHide = () => {
  setErr(false);
  setOpen(false);
 };

 const onRed = (social, icon) => {
  setFormData({ social, icon, url: watch('socials').find(e => e.social === social)?.url || '' });
  setOpen(true);
 };

 const setSocial = () => {
  const isVal = formData.url ? validateURL(formData.url) : true;
  if (!isVal) {
   toast.error('Url de red social invalida');
   return setErr(true);
  }
  const socals = formData.url
   ? [...watch('socials').filter(e => e.social !== formData?.social), formData]
   : watch('socials').filter(e => e.social !== formData?.social);
  setValue('socials', socals);
  setOpen(false);
 };

 useEffect(() => {
  if (errors?.socials) {
   setFormData(watch('socials').find(e => !validateURL(e.url)));
   toast.error('Url de red social invalida');
   setErr(true);
   setOpen(true);
  }
 }, [errors?.socials]);

 /* useEffect(() => {
  const subscription = watch(value => {
   console.log('algo cambio', value);
  });
  return () => subscription.unsubscribe();
 }, [watch]); */

 return (
  <Flex className="position-relative" alignItems="center" wrap="wrap">
   <div className="position-absolute start-50 top-50 translate-middle z-index-1 w-100">
    <div className={classNames('position-relative fs--1', { 'd-none': !open })}>
     <Input
      type="text"
      name="socials"
      placeholder="Url de la red social"
      formGroupProps={{
       className: classNames('border rounded-pill', {
        'bg-soft-danger border-danger': err,
        'bg-soft-primary border-info': !err
       })
      }}
      formControlProps={{
       onChange: onChange,
       autoComplete: 'off',
       className: 'px-4 py-0 w-100',
       value: formData.url,
       size: 'sm',
       plaintext: true
       //style: { outline: 'none' }
      }}
     />
     <FontAwesomeIcon icon={formData?.icon ?? 'user'} className="position-absolute start-0 top-50 translate-middle-y ms-2" />
     {err && <FontAwesomeIcon icon="ban" className="position-absolute end-0 top-50 translate-middle-y me-5 text-danger" />}
     <Button
      variant="link"
      type="button"
      onClick={setSocial}
      className="fs--2 text-700 p-0 me-4 position-absolute end-0 top-50 translate-middle-y"
     >
      <FontAwesomeIcon icon="arrow-right" />
     </Button>

     <Button
      variant="link"
      type="button"
      onClick={onHide}
      className="fs--2 text-700 p-0 me-2 position-absolute end-0 top-50 translate-middle-y"
     >
      <FontAwesomeIcon icon="times" />
     </Button>
    </div>
   </div>

   <div className="flex-fill fs--2 hover-actions-trigger">
    <Button
     variant="link"
     type="button"
     target="_blank"
     href={watch('socials').find(e => e.social === 'Facebook')?.url || ''}
     className={classNames('fs--1 p-0 me-2', {
      'text-700': !watch('socials').some(e => e.social === 'Facebook'),
      'text-facebook': watch('socials').some(e => e.social === 'Facebook')
     })}
    >
     <Flex alignItems="center" wrap="wrap">
      <FontAwesomeIcon icon={['fab', 'facebook']} transform="shrink-2" />
      <span className={classNames({ 'd-none d-sm-block ms-1': smHiden })}>Facebook</span>
     </Flex>
    </Button>

    <div className="hover-actions end-0 top-50 translate-middle-y me-0 me-md-2">
     <Button variant="link" type="button" className="fs--2 text-700" onClick={() => onRed('Facebook', ['fab', 'facebook'])}>
      <FontAwesomeIcon icon="pencil-alt" />
     </Button>
    </div>
   </div>
   <div className="flex-fill fs--2 hover-actions-trigger">
    <Button
     variant="link"
     type="button"
     target="_blank"
     href={watch('socials').find(e => e.social === 'Instagram')?.url || ''}
     className={classNames('fs--1 p-0 me-2', {
      'text-700': !watch('socials').some(e => e.social === 'Instagram'),
      'text-instagram': watch('socials').some(e => e.social === 'Instagram')
     })}
    >
     <Flex alignItems="center" wrap="wrap">
      <FontAwesomeIcon icon={['fab', 'instagram']} transform="shrink-2" />
      <span className={classNames({ 'd-none d-sm-block ms-1': smHiden })}>Instagram</span>
     </Flex>
    </Button>
    <div className="hover-actions end-0 top-50 translate-middle-y me-0 me-md-2">
     <Button variant="link" type="button" className="fs--2 text-700" onClick={() => onRed('Instagram', ['fab', 'instagram'])}>
      <FontAwesomeIcon icon="pencil-alt" />
     </Button>
    </div>
   </div>
   <div className="flex-fill fs--2 hover-actions-trigger">
    <Button
     variant="link"
     type="button"
     target="_blank"
     href={watch('socials').find(e => e.social === 'Linkedin')?.url || ''}
     className={classNames('fs--1 p-0 me-2', {
      'text-700': !watch('socials').some(e => e.social === 'Linkedin'),
      'text-linkedin': watch('socials').some(e => e.social === 'Linkedin')
     })}
    >
     <Flex alignItems="center" wrap="wrap">
      <FontAwesomeIcon icon={['fab', 'linkedin']} transform="shrink-2" />
      <span className={classNames({ 'd-none d-sm-block ms-1': smHiden })}>Linkedin</span>
     </Flex>
    </Button>
    <div className="hover-actions end-0 top-50 translate-middle-y me-0 me-md-2">
     <Button variant="link" type="button" className="fs--2 text-700" onClick={() => onRed('Linkedin', ['fab', 'linkedin'])}>
      <FontAwesomeIcon icon="pencil-alt" />
     </Button>
    </div>
   </div>
  </Flex>
 );
};

Socials.propTypes = {
 watch: PropTypes.func.isRequired,
 setValue: PropTypes.func.isRequired,
 errors: PropTypes.object,
 smHiden: PropTypes.bool
};

export default Socials;
